package com.starparty.app.astro0

import com.starparty.app.vector_maths.Matrix4d
import com.starparty.app.vector_maths.Point3d

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class EquatorialCoords(rotation: Matrix4d) : SphericalCoords(rotation) {
    /** Sets the viewpoint looking along the z-axis to the specified
     * equatorial coordinates (in decimal degrees).  */
    fun setEquatorialCoordinates(ra: Double, dec: Double) {
        itsRotation.setIdentity()
        itsRotIncMatrix.setIdentity()
        itsRotation.rotY(ra * MathD.DEG_TO_RAD)
        itsRotIncMatrix.rotX(-dec * MathD.DEG_TO_RAD)
        itsRotation.mul(itsRotIncMatrix)
        isInverseRotCurrent = false
    }

    fun equSphericalToViewCartesian(ra: Double, dec: Double): Point3d {
        val cart = Point3d()
        SphericalCoords.sphericalToCartesian(ra, dec, cart)
        applyRotation(cart)
        return cart
    }

    fun equSphericalToViewSpherical(ra: Double, dec: Double): SphPoint {
        val viewSph = SphPoint()
        val cart = equSphericalToViewCartesian(ra, dec)
        SphericalCoords.cartesianToSpherical(cart, viewSph)
        return viewSph
    }

    fun equCartesianToViewSpherical(
        x: Double,
        y: Double,
        z: Double
    ): SphPoint {
        val cart = Point3d(x, y, z)
        val sph = SphPoint()
        applyRotation(cart)
        SphericalCoords.cartesianToSpherical(cart, sph)
        return sph
    }

    fun viewCartesianToEquatorialSpherical(c: Point3d?): SphPoint {
        invertRotateCartesian(c!!)
        val equCoords = SphPoint()
        SphericalCoords.cartesianToSpherical(c, equCoords)
        return equCoords
    }
}